/**
 * Transient "I'm playing this discipline FOR a tournament" context. Set when the player taps
 * "Gioca" on a discipline inside a tournament, consumed by the next race finish (which submits
 * the result to the Arena) and then cleared. Module-level singleton — only one race at a time.
 */
export interface ArenaPlay {
  tournamentId: string;
  tournamentName: string;
  disciplineId: string;
}

let current: ArenaPlay | null = null;
let setAt = 0;
const MAX_AGE_MS = 30 * 60_000; // a stale context (player wandered off) shouldn't attach later

export function setArenaPlay(ctx: ArenaPlay | null): void {
  current = ctx;
  setAt = Date.now();
}
export function getArenaPlay(): ArenaPlay | null {
  if (current && Date.now() - setAt > MAX_AGE_MS) current = null;
  return current;
}
export function clearArenaPlay(): void {
  current = null;
}
